import { useFormContext } from "react-hook-form";
import { ControlledTextarea } from "@dune/ui";
import { OperationDescriptionFormData } from "./useOperationDescriptionForm";

interface OperationDescriptionFormProps {
	disabled?: boolean;
	showCoOwnersSyndicDenomination?: boolean;
}

export const OperationDescriptionForm = ({
	disabled = false,
	showCoOwnersSyndicDenomination = false,
}: OperationDescriptionFormProps) => {
	const form = useFormContext<OperationDescriptionFormData>();
	const { control } = form;

	return (
		<div className="flex flex-col gap-4">
			{showCoOwnersSyndicDenomination && (
				<ControlledTextarea
					name="coOwnersSyndicDenomination"
					control={control}
					label="Dénomination du syndicat des copropriétaires"
					disabled={disabled}
					rows={4}
				/>
			)}
			<ControlledTextarea
				name="operationDescription"
				control={control}
				label="Description de l'opération"
				disabled={disabled}
				rows={4}
			/>
		</div>
	);
};
